import script from "./AIChatModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AIChatModal.vue?vue&type=script&setup=true&lang=js"

import "./AIChatModal.vue?vue&type=style&index=0&id=91d98980&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91d98980"]])

export default __exports__